import React, { ComponentProps } from 'react';

import { BasicButton } from '@adsk/alloy-react-button';
import { XIcon } from '@adsk/alloy-react-icon';
import { WithAlloySuspense } from '@adsk/alloy-react-suspense';
import theme from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip';

import { useTranslation } from './i18n';

type Props = Omit<ComponentProps<typeof BasicButton>, 'onClick'> & {
  onClick: () => void;
  tooltipProps?: Partial<ComponentProps<typeof Tooltip>>;
};

const BlockRemoveButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ className, style, onClick, tooltipProps, ...props }, ref) => {
    const { t } = useTranslation();

    return (
      <Tooltip {...tooltipProps} content={t('REMOVE')}>
        <BasicButton
          ref={ref}
          className={className}
          style={[
            {
              color: theme.colors.red700,
              border: `1px solid ${theme.colors.charcoal400}`,
              borderRadius: 2,
              padding: 3,
              width: 24,
              height: 24,
            },
            style,
          ]}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClick();
          }}
          {...props}
        >
          <XIcon size={16} />
        </BasicButton>
      </Tooltip>
    );
  },
);

BlockRemoveButton.displayName = 'BlockRemoveButton';

export default WithAlloySuspense(BlockRemoveButton);
